import mediator, { MediatorRequestWithResponse } from '../utilities/mediator';
import { urls } from '../utilities/dataHelpers';
import { Role } from '../models';
import { mapRoleEntityToRole } from '../utilities/mappers';
import {
  ApiEndpoints,
  EntityState,
  EntityType,
  Role as RoleEntity,
} from 'adc-sirius-module-common';

const handleGetRoles = (
  request: MediatorRequestWithResponse<Role[]> & {
    entityType?: EntityType;
    rowState?: EntityState;
  },
) => {
  const query: Record<string, string> = {};

  if (request.entityType) {
    query.entity_type = request.entityType;
  }

  if (request.rowState) {
    query.row_state = String(request.rowState);
  }

  const url = urls.api + ApiEndpoints.EP_ROLE_GET.Path;

  request.response = new Promise<Role[]>((resolve, reject) => {
    mediator
      .request<RoleEntity[]>('api:invoke', {
        method: ApiEndpoints.EP_ROLE_GET.Method,
        url,
        query,
      })
      .then((result) => {
        if (result.status === 200) {
          resolve(result.data.map(mapRoleEntityToRole));
        } else {
          reject(result);
        }
      })
      .catch((err) => {
        reject(err);
      });
  });
};

mediator.subscribe('role:getRoles', handleGetRoles);
